import { Dashboard } from '@components/dashboard';
import { DashboardItem } from '@components/dashboard/item';
import { JobAlert } from '@components/job/workProgress/alert';
import { JobDate } from '@components/job/workProgress/date';
import { getJobStatus, isWithoutSchedule, sortByProp } from '@components/job/workProgress/helpers';
import { JobStageMenu } from '@components/job/workProgress/stage/menu';
import { JobTask } from '@components/job/workProgress/task';
import { Rescheduler } from '@components/rescheduler';
import { useJobContext } from '@contexts/job';
import { initialState } from '@contexts/job/constants';
import { sortByDate } from '@components/hotSeat/utils';
import { JobStage as JobStageType, JobTaskData, JobTask as JobTaskType } from '@root/globalTypes';
import { parseISO } from 'date-fns';
import { Fragment } from 'react';
import { JobStageRemove } from '@components/job/workProgress/stage/remove';

export const WorkProgress = () => {
  const { stages, isLoading, rescheduler, setState } = useJobContext();

  return (
    <>
      <Dashboard isLoading={isLoading.stages} className="pl-3 pt-2">
        {sortByProp<JobStageType>(stages, 'position', 'asc').map((stage) => (
          <DashboardItem
            key={`dashboard-item-${stage.id}`}
            id={stage.id}
            title={
              <div className="flex items-center gap-2.5">
                <h2 className="text-lg font-bold text-neutral-800">{stage.name}</h2>
                <JobAlert status={getJobStatus(stage)} alerts={stage.alerts} />
              </div>
            }
            actions={
              <>
                {stage.manuallyAdded && <JobStageRemove stageId={stage.id} name={stage.name} />}
                <JobStageMenu
                  jobId={stage.jobId}
                  stageId={stage.id}
                  multi={stage.multiplicableTasks}
                />
              </>
            }
            body={
              <>
                {sortByProp<JobTaskType>(
                  stage.tasks.find((el) => isWithoutSchedule(el))?.tasks || [],
                  'position',
                  'asc',
                ).map((t) => (
                  <JobTask key={t.id} data={t} stage={stage} />
                ))}
                {sortByDate<JobTaskData>(
                  stage.tasks.filter((el) => !isWithoutSchedule(el)),
                  'date',
                  'asc',
                ).map((el, index) => (
                  <Fragment key={`job-stage-day-${index}`}>
                    <JobDate date={parseISO(el.date)} />
                    {sortByProp<JobTaskType>(el.tasks, 'position', 'asc').map((t) => (
                      <JobTask key={t.id} data={t} date={el.date} stage={stage} />
                    ))}
                  </Fragment>
                ))}
              </>
            }
          />
        ))}
      </Dashboard>
      <Rescheduler {...rescheduler} setOpen={() => setState(initialState)} />
    </>
  );
};
